import { DataType } from "./AnalyticsTracker";

import { LoginResponseUser } from "@api-types/user/LoginResponseDto";

import { Plugins } from "@capacitor/core";
const { xtremepushplugin } = Plugins;

export class CapacitorXtremePushProvider {
	private isXtremeEnabled(): boolean {
		return WEBPACK_ANALYTICS_PROVIDERS.includes("xp-mobile-app");
	}

	constructor() {}

	public async setUserId(userData: LoginResponseUser) {
		if (!this.isXtremeEnabled()) {
			return;
		}

		if (!userData) {
			console.error("Missing user data");
			return;
		}

		try {
			if (!userData.id || !userData.agencyId) {
				console.error("Missing userId or agencyId");
				return;
			}

			await xtremepushplugin.setUserId({
				userId: `${userData.userNumericalId}_${userData.id}`,
			});
		} catch (error) {
			console.error("Error with shooting xtremepush setUserId", error);
			return;
		}
	}

	public async trackPageView(eventName: string, url: string) {
		if (!this.isXtremeEnabled()) {
			return;
		}

		await xtremepushplugin.trackEvent({
			eventName: eventName,
			eventData: { url: url, title: document.title },
		});
	}

	public async trackEvent(eventName: string, data: DataType) {
		if (!this.isXtremeEnabled()) {
			return;
		}

		await xtremepushplugin.trackEvent({
			eventName: eventName,
			eventData: data,
		});
	}
}
